export const NOTIFICATIONS_DEFAULT_SETTINGS = {
  ALARMS: {
    ALARM_CARDS_EXPIRATION_MONTHS_2_SMS: false,
    ALARM_CARDS_EXPIRATION_MONTHS_2_EMAIL: false,
    ALARM_CARDS_EXPIRATION_MONTHS_2_APPLICATION: false,
    ALARM_CARDS_EXPIRATION_MONTHS_1_SMS: false,
    ALARM_CARDS_EXPIRATION_MONTHS_1_EMAIL: true,
    ALARM_CARDS_EXPIRATION_MONTHS_1_APPLICATION: true,
    ALARM_CARDS_EXPIRATION_DAYS_14_SMS: true,
    ALARM_CARDS_EXPIRATION_DAYS_14_EMAIL: true,
    ALARM_CARDS_EXPIRATION_DAYS_14_APPLICATION: true,
    ALARM_CARDS_EXPIRATION_DAYS_7_SMS: false,
    ALARM_CARDS_EXPIRATION_DAYS_7_EMAIL: false,
    ALARM_CARDS_EXPIRATION_DAYS_7_APPLICATION: true,
    ALARM_CARDS_EXPIRATION_DAYS_0_SMS: true,
    ALARM_CARDS_EXPIRATION_DAYS_0_EMAIL: true,
    ALARM_CARDS_EXPIRATION_DAYS_0_APPLICATION: true,
  },
};
